(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("millan", [], factory);
	else if(typeof exports === 'object')
		exports["millan"] = factory();
	else
		root["millan"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 